site.megamenu = {
	init:function() {
		var $body = $('body');
		var $mainmenu = $('#mainmenu');

		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"></div>');

		$('.level1.children > a',$mainmenu).on('click touchstart', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					// site.headSearch.close(true);
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					var $parent = $(this).parent();
					$parent.addClass('open');
					$parent.find('.mmLevel2 .level2.children').first().find('> a').trigger('mouseenter');

					if (!$body.hasClass('megamenu-open')) {
						$body.addClass('megamenu-opening');

						setTimeout(function() {
							$body.removeClass('megamenu-opening');
							if (!$body.is('.megamenu-closing')) {
								$body.addClass('megamenu-open');
							}
						},400);
					}
				}
			}
		});

		$(document).on('click touchstart', function(e) {
			if ($('body').is('.megamenu-open')) {
				var container = $(".megamenu");

				if (!container.is(e.target) && container.has(e.target).length === 0) {
					site.megamenu.close();
				}
			}
		});

		$(document).keyup(function(e) {
			if (e.key === "Escape") {
				site.megamenu.close();
			}
		});
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.level1.open', $mainmenu).removeClass('open');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
				$('.mmLevel3').removeClass('open');
			},400);
		}
		$body.removeClass('megamenu-open');
	}
};
